module.exports = __webpack_public_path__ + "img/8.34036a17.png";